import { useState, useRef } from "react";
var useCaptcha = function () {
    var captchaRef = useRef(null);
    var _a = useState(""), captchaError = _a[0], setCaptchaError = _a[1];
    var _b = useState(null), captchaToken = _b[0], setCaptchaToken = _b[1];
    var onCaptchaChange = function (newToken) {
        setCaptchaToken(newToken);
    };
    var resetCaptcha = function () {
        var _a;
        if (captchaRef !== null && captchaRef.current !== null) {
            (_a = captchaRef === null || captchaRef === void 0 ? void 0 : captchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
        }
    };
    return {
        captchaToken: captchaToken,
        onCaptchaChange: onCaptchaChange,
        captchaError: captchaError,
        setCaptchaError: setCaptchaError,
        captchaRef: captchaRef,
        resetCaptcha: resetCaptcha,
    };
};
export default useCaptcha;
//# sourceMappingURL=useCaptcha.js.map